<template><App :keepAliveInclude="keepAliveInclude"/></template><script>
import { getQueryParams, goFidId, getStorageSyncWithExpiration } from '@/utils/index.js'

export default {
	globalData: {
		// 有多少个同时进行的请求，用来显示loading
		reqNum: 0,
		env: 'h5',
		logining: false, // 同时执行1个登录代码
		deviceCode: '',
		isFrist: false,//
		upFid: false,
		safeArea: {
			top: 0,
			bottom: 0
		},
		// 小程序右上角按钮/胶囊信息
		programInfo: {},
		showGuide: false
	},
	onLaunch: function (options) {
		console.log('最先执行onLaunch', options)
		// console.log('全局options',options);
		// 获取关联普通链接二维码的码值（即二维码地址），放到全局变量 qrCode中 
		if (options.query && options.query.qrCode) {
			this.globalData.deviceCode = options.query.qrCode
		}
		const systemInfo = uni.getSystemInfoSync();
		console.log('安全距离 systemInfo', systemInfo)
		if (systemInfo.safeAreaInsets) {
			this.globalData.safeArea = systemInfo.safeAreaInsets;
		}
		// #ifdef MP-WEIXIN
		let menuButtonInfo = uni.getMenuButtonBoundingClientRect()
		console.log('胶囊信息 menuButtonInfo', menuButtonInfo)
		if (menuButtonInfo) {
			this.globalData.programInfo = menuButtonInfo;
		}
		// #endif
		// 朋友圈打开首屏显示打开小程序指引
		if (options.scene == 1154) {
			this.globalData.showGuide = true;
		}
	},
	onShow: function (options) {
		// console.log('App Show')
		// console.log('App Show options:', options)
		// this.$nextTick(() => {
		// 	// 用户已经打开了小程序，不再执行onLaunch
		// 	if (!this.globalData.upFid) {
		// 		// 打开分享
		// 		if (options.query && options.query.fid) {
		// 			uni.setStorageSync('fid', options.query.fid)
		// 			goFidId();
		// 		}
		// 		// 识别二维码（海报）
		// 		if (options.query && options.query.q) {
		// 			const q = decodeURIComponent(options.query.q) // 获取到二维码原始链接内容  
		// 			let params = getQueryParams(q)
		// 			if (params.fid) {
		// 				uni.setStorageSync('fid', params.fid)
		// 				goFidId()
		// 			}
		// 		}
		// 		// 识别二维码(防止失败)
		// 		if (options.q) {
		// 			const q = decodeURIComponent(options.q) // 获取到二维码原始链接内容  
		// 			let params = getQueryParams(q)
		// 			if (params.fid) {
		// 				uni.setStorageSync('fid', params.fid)
		// 				goFidId()
		// 			}
		// 		}
		// 		// 直接传参(防止失败)
		// 		if (options.fid) {
		// 			uni.setStorageSync('fid', options.fid)
		// 			goFidId()
		// 		}
		// 		// 通过分享商品海报进入
		// 		if (options.query && options.query.scene) {
		// 			const q = decodeURIComponent(options.query.scene) // 获取到二维码原始链接内容
		// 			// console.log('g=1227&u=199')
		// 			const match = q.match(/u=(\d+)/);
		// 			const fid = match ? match[1] : null;
		// 			console.log('fid', fid);
		// 			uni.setStorageSync('fid', fid)
		// 			goFidId()
		// 		}
		// 	}
		// })

		let token = getStorageSyncWithExpiration("token");
		// 判断是否已经登录
		if (!token) {
			// 未登录
			// #ifdef H5
			const href = window.location.href
			if (href.includes('code')) {
				// 判断是否跳转授权后返回到该页面，并带回code
				const code = getQueryParams('code')
			} else {
				// let wxUrl =  `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${'wx26cc926f52b18048'}&redirect_uri=${'https://zs.jinzancn.com/securepanel'}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`
				// window.location.href = wxUrl;
			}
			// #endif
		}
	},
	onHide: function () {
		console.log('App Hide')
	}
}
</script>

<style>
/*每个页面公共css */
@import url('/static/icon/iconfont.css');

page {
	background: #f5f5f5;
}
</style>